import React from "react";
import client from "@culturehq/client";
import { Loader } from "@culturehq/components";

import { useFetch } from "app/hooks";

import ErrorMessage from "components/common/ErrorMessage";

import SurveyItems from "./SurveyItems";

const SurveyTake = ({ event = null, survey, onSurveyComplete }) => {
  const { error, fetching, json: { submittedResponses } } = useFetch(
    () => client.listSurveySubmittedResponses({ surveyId: survey.id }),
    [survey]
  );

  if (error) {
    return (
      <div className="col-sm-12">
        <ErrorMessage error={error} />
      </div>
    );
  }

  return (
    <div className="SurveyPage">
      <Loader loading={fetching}>
        <SurveyItems
          survey={survey}
          event={event}
          submittedResponses={submittedResponses}
          onSurveyComplete={onSurveyComplete}
        />
      </Loader>
    </div>
  );
};

export default SurveyTake;
